import dayjs from "dayjs";

const MonthType = Symbol();

export class Month {
    [MonthType]: any;
    readonly year: number;
    readonly month: number;

    private constructor(year: number, month: number) {
        this.year = year;
        this.month = month;
    }

    equals(other: Month | null): boolean {
        if (!other) return false;
        return this.year === other.year && this.month === other.month;
    }

    isEqualsOrGreaterThan(other: Month): boolean {
        return (this.equals(other) || this.isGreaterThan(other));
    }

    isEqualsOrGreaterThanThisMonth(): boolean {
        return this.isEqualsOrGreaterThan(Month.thisMonth());
    }

    isGreaterThan(other: Month): boolean {
        return dayjs(this.format()).isAfter(dayjs(other.format()));
    }

    isGreaterThanToday(): boolean {
        return this.isGreaterThan(Month.thisMonth());
    }

    format(): string {
        return `${this.year.toString().padStart(4, "0")}-${this.month.toString().padStart(2, "0")}`;
    }

    japaneseFormat(zeroPad: boolean = true): string {
        if (zeroPad) {
            const year = this.year.toString().padStart(4, "0");
            const month = this.month.toString().padStart(2, "0");
            return `${year}年${month}月`;
        } else {
            return `${this.year}年${this.month}月`;
        }
    }

    previous(): Month {
        return Month.fromString(dayjs(`${this.format()}-01`).add(-1, "month").format("YYYY-MM"));
    }

    next(): Month {
        return Month.fromString(dayjs(`${this.format()}-01`).add(1, "month").format("YYYY-MM"));
    }

    static thisMonth(): Month {
        return Month.fromDayJs(dayjs());
    }

    private static fromDayJs(dayjs: dayjs.Dayjs): Month {
        return Month.fromString(dayjs.format("YYYY-MM"));
    }

    static fromString(yearMonthString: string): Month {
        assertFormat(yearMonthString);
        return new Month(
            Number(yearMonthString.substr(0, 4)),
            Number(yearMonthString.substr(5, 2))
        );
    }

    static isYearMonthFormat = (str: string): boolean => {
        // yyyy-mmの形式をチェック
        if (! /\d{4}-\d{2}/.test(str)) return false;

        // 月が1-12かチェック
        const month = Number(str.substr(5, 2));
        if (month < 1 || 12 < month) return false;
        return true;
    };
}

class InvalidYearMonthFormatError extends Error {}

const assertFormat = (str: string) => {
    if (!Month.isYearMonthFormat(str)) {
        throw new InvalidYearMonthFormatError("month must be format with 'yyyy-mm'");
    }
};
